module.exports = __webpack_public_path__ + "img/logoShort.1aa49bc7.svg";